/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface BulkDeleteNotificationsResponse
 */
export interface BulkDeleteNotificationsResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof BulkDeleteNotificationsResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the BulkDeleteNotificationsResponse interface.
 */
export function instanceOfBulkDeleteNotificationsResponse(value: object): value is BulkDeleteNotificationsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkDeleteNotificationsResponseFromJSON(json: any): BulkDeleteNotificationsResponse {
    return BulkDeleteNotificationsResponseFromJSONTyped(json, false);
}

export function BulkDeleteNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteNotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function BulkDeleteNotificationsResponseToJSON(json: any): BulkDeleteNotificationsResponse {
      return BulkDeleteNotificationsResponseToJSONTyped(json, false);
  }

  export function BulkDeleteNotificationsResponseToJSONTyped(value?: BulkDeleteNotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

